import {
  BueroTypeResult,
  FactorValues,
  ResultPropsEinzelbueros,
  ResultPropsGenericWithOriginal,
  ResultPropsSonderbedarfe,
  ResultPropsStauflaeche,
  ResultPropsWorkstation,
} from './FactorValues'
import { Answer } from '../Answer/Answer'
import { Survey } from '../Survey'
import { Analysis } from './Analysis'
import { PrebuildType } from '../Element'
import { OptimizationMode } from './Concept'
import { ProductionDistance } from '../../OrganizationUnit'

export enum BueroType {
  KOMFORT = 'KOMFORT',
  FLEX = 'FLEX',
  AGIL = 'AGIL',
  ZELLSTRUKTUR = 'ZELLSTRUKTUR',
  OPEN_SPACE = 'OPEN_SPACE',
}

export type DesksharingPercentage = {
  percentage: number
  originalPercentage: number
}

export type AnwesenheitPercentage = {
  percentage: number
  originalPercentage: number
  answerAmount: number
}

export enum SplitOption {
  HARD = 'HARD',
  SOFT = 'SOFT',
}

export type Values = {
  unitUUID: string
  name: string
  originUnitUUID: string
  splitOption: SplitOption
  productionDistance: ProductionDistance
  anwesenheitPercentage: AnwesenheitPercentage
  desksharingPercentage: DesksharingPercentage
  mitarbeiter: number
  originalMitarbeiter: number
  drucker: ResultPropsGenericWithOriginal
  locker: ResultPropsGenericWithOriginal
  workcafe: ResultPropsGenericWithOriginal
  garderobe: ResultPropsGenericWithOriginal
  [PrebuildType.EINZELBUEROS]: ResultPropsEinzelbueros
  [PrebuildType.STAUFLAECHE]: ResultPropsStauflaeche
  [PrebuildType.SONDERBEDARFE]: ResultPropsSonderbedarfe[]
  [PrebuildType.WORKSTATIONS]: ResultPropsWorkstation
  factor: FactorValues
  optimizationMode: OptimizationMode

  // dynamic properties
  ergebnisse?: BueroTypeResult
  teamSurvey?: Survey
  managerSurvey?: Survey
  leaderSurvey?: Survey
  analysis?: Analysis
  managerAnswer?: Answer
  leaderAnswer?: Answer
}

export type OrganizationUnitList = {
  [unitUUID: string]: Values
}

export type ErgebnisByBueroType = OrganizationUnitList & { sum?: BueroTypeResult }

export type ErgebnisseByBueroType = {
  [bueroType in BueroType]: ErgebnisByBueroType
}

export type Calculation = {
  ergebnisseByBueroType?: ErgebnisseByBueroType
}
